import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { translate, TranslocoPipe } from '@jsverse/transloco';
import { DialogComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-assessment-confirm-dialog',
    templateUrl: './assessment-confirm-dialog.component.html',
    styleUrls: ['./assessment-confirm-dialog.component.scss'],
    imports: [TranslocoPipe, DialogComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssessmentConfirmDialogComponent {
    private dialogVisible: boolean = false;

    @Input()
    dialogTitle: string = translate('ASSESSMENT.COMMON.CONFIRM_DIALOG.DELETE.TITLE');

    @Input()
    dialogDescription!: string;

    @Input()
    set visible(value: boolean) {
        if (this.dialogVisible != value) {
            this.dialogVisible = value;
            this.visibleChange.emit(this.dialogVisible);
        }
    }
    get visible(): boolean {
        return this.dialogVisible;
    }

    @Output()
    visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Output()
    delete: EventEmitter<void> = new EventEmitter();

    clickYes() {
        this.delete.emit();
        this.visible = false;
    }
}
